import { Button, Flex, Grid, useStyles, pxToRem } from '@archipro-design/aria';
import type { TileProps } from '../../type';
import SectionHeader from '../section-header/SectionHeader';
import * as S from './FilmsSection.style';
import ArticleVideoTile from '@modules/articles/component/article-video-tile/ArticleVideoTile';
import { NavLink } from 'react-router';
import { FILMS_CATEGORY_LINK } from '@modules/articles/config/constants';

interface LatestArticlesProps {
    title: string;
    latestArticles: TileProps[];
    loadMoreLink?: string;
}

const FilmsSectionMobile = ({ title, latestArticles }: LatestArticlesProps) => {
    const { css } = useStyles();

    return (
        <>
            <Flex className={css(S.Header)}>
                <SectionHeader title={title} />
            </Flex>
            <Grid className={css(S.FilmsGrid)} columns={2}>
                {latestArticles.map((article) => {
                    article.variant = '06';
                    article.size = 'small';
                    return (
                        <ArticleVideoTile
                            key={`archizeen_tile_container--${article.ID}`}
                            article={article}
                            imageWidth={204}
                            iconSizeOverride={50}
                        />
                    );
                })}
            </Grid>
            <Button
                className={css(S.ViewMore)}
                size={16}
                as={NavLink}
                to={FILMS_CATEGORY_LINK}
                prefetch={'intent'}
                variables={{
                    buttonPadding: pxToRem(15),
                }}
                outlined
                transparent
            >
                VIEW MORE
            </Button>
        </>
    );
};
export default FilmsSectionMobile;
